import React, { useState } from 'react';
import {
  Box,
  Paper,
  Tab,
  Tabs
} from '@material-ui/core';

import ProcessesTable from 'components/Processes/ProcessesTable';

const ProcessListResults = (props) => {

  const [userTabValue, setUserTabValue] = useState(0);

  const handleUserTabChange = (event, newValue) => {
    setUserTabValue(newValue);
  };

  return (
    <Box>
      <Box
        sx={{
          display: 'flex'
        }}
      >
        <Paper>
          <Tabs
            value={userTabValue}
            indicatorColor="primary"
            textColor="primary"
            onChange={handleUserTabChange}
            centered
          >
            {props.user.standardUsers ? props.user.standardUsers.map((user) => (<Tab key={user.id} label={user.name} />)) : null}
          </Tabs>
        </Paper>
      </Box>
      <Box marginTop={1}>
        <ProcessesTable
          userTabValue={userTabValue}
          products={props.products}
          processes={props.processes}
          vendors={props.vendors}
          salesOrders={props.salesOrders}
          user={props.user}
        />
      </Box>
    </Box>
  )
};

export default ProcessListResults;